import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const MobileIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 10 16" {...props}>
      <path
        d="M7.66797 0.666992H2.33464C1.41464 0.666992 0.667969 1.41366 0.667969 2.33366V13.667C0.667969 14.587 1.41464 15.3337 2.33464 15.3337H7.66797C8.58797 15.3337 9.33463 14.587 9.33463 13.667V2.33366C9.33463 1.41366 8.58797 0.666992 7.66797 0.666992ZM5.0013 14.667C4.44797 14.667 4.0013 14.2203 4.0013 13.667C4.0013 13.1137 4.44797 12.667 5.0013 12.667C5.55464 12.667 6.0013 13.1137 6.0013 13.667C6.0013 14.2203 5.55464 14.667 5.0013 14.667ZM8.0013 12.0003H2.0013V2.66699H8.0013V12.0003Z"
        fill="#1FD4AF"
      />
    </SvgIcon>
  );
};

export default MobileIcon;
